import * as React from 'react';
import { State } from '~/store/types';
import connect from '~/store/connect';
import { ChartFilter, Line, OldLineChart } from '@watcherr/charts';
import { Panel } from '@ixicare/ui';

import { alertActivityFilters } from '~/config/dashboard';
import Tooltip from './Tooltip';

interface DashboardAlertActivityContainerProps {
  lines: Line[];
  loading: boolean;
  filter: State['graphs']['alertActivity']['filter'];
  filterChanged: State['graphs']['alertActivity']['filterChanged'];
  tooltipWithTimestamp: boolean;
}

// Fetching is driven by DashboardPage on selectedSite change (initial load +
// site switches), so this component no longer self-fetches on mount.
const DashboardAlertActivityContainer: React.FC<DashboardAlertActivityContainerProps> = ({
  lines,
  loading,
  filter,
  filterChanged,
  tooltipWithTimestamp,
}) => {
  const getTooltipContent = React.useCallback(
    (x: Date) => <Tooltip tooltipWithTimestamp={tooltipWithTimestamp} lines={lines} xValue={x} />,
    [lines]
  );

  return (
    <>
      <Panel.Right>
        <ChartFilter value={filter} onChange={filterChanged} items={alertActivityFilters} />
      </Panel.Right>
      <OldLineChart lines={lines} loading={loading} getTooltipContent={getTooltipContent} />
    </>
  );
};

export default connect((state: State) => ({
  lines: state.graphs.alertActivity.lines,
  tooltipWithTimestamp: state.graphs.alertActivity.tooltipWithTimestamp,
  loading: state.graphs.alertActivity.loading,
  filter: state.graphs.alertActivity.filter,
  filterChanged: state.graphs.alertActivity.filterChanged,
}))(DashboardAlertActivityContainer);
